import React from "react";
import { useTranslation } from "react-i18next";
import {
  FbIcon,
  YtIcon,
  IgIcon,
  TwIcon,
  FooterContainer,
  FooterWrap,
  FooterLegal,
  Icon,
  FooterLink,
  FooterP,
  FooterReserved,
  FooterSocialMedia,
} from "./footerElements";

const Footer = () => {
  const {t} = useTranslation();
  return (
    <FooterContainer>
      <FooterWrap>
        <FooterReserved>
          <FooterP>{t('footerP.txt')}</FooterP>
        </FooterReserved>
        <FooterLegal>
          <FooterLink to="https://gdpr-info.eu/">{t('footerPP.txt')}</FooterLink>
        </FooterLegal>

        <FooterSocialMedia>
          <Icon onClick={""}>
            <FbIcon />
          </Icon>
          <Icon onClick={""}>
            <YtIcon />
          </Icon>
          <Icon onClick={""}>
            <IgIcon />
          </Icon>
          <Icon onClick={""}>
            <TwIcon />
          </Icon>
        </FooterSocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
